import s from "./secondSlide.module.css";
import {useSecondSlide} from "./useSecondSlide";
import {productCartIcon, SSMPlayIcon} from "../../../../assets";
import ProgressBar from "../ProgressBar";
import {Fragment} from "preact";

const SecondSlide = (props) => {
    // Destructured props
    const {
        selfServiceAttendanceModalData,
        currentSlide,
        handleCurrentSlide,
        TOTAL_SLIDES,
        render
    } = props;

    // Component logic data
    const componentProps = useSecondSlide({
        currentSlide,
        selfServiceAttendanceModalData,
    });

    // Destructured component logic data
    const {
        isUnlocked,
        videoRef,
        videoUrl,
        handleIsUnlocked,
    } = componentProps;

    // The actual video player
    const player = (
        <div className={`w-full h-full absolute top-0 left-0 z-0`}>
            {videoUrl ? (
                <Fragment>
                    {/*<iframe*/}
                    {/*    src={`https://www.youtube.com/embed/${videoUrl}`}*/}
                    {/*    title="Youtube Video"*/}
                    {/*    frameBorder="0"*/}
                    {/*    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"*/}
                    {/*    referrerPolicy="strict-origin-when-cross-origin"*/}
                    {/*    allowFullScreen*/}
                    {/*    className={`w-full h-full`}*/}
                    {/*/>*/}
                    <video
                        ref={videoRef}
                        className={`w-full h-full aspect-video ${s.renderVideo}`}
                        autoPlay={true}
                        controls={true}
                    >
                        <source
                            src={`/media/${videoUrl}`}
                            type="video/mp4"
                        />
                    </video>
                </Fragment>
            ) : (
                <div className={`w-full h-full bg-transparent text-white flex justify-center items-center p-4`}>
                    <h1>
                        Nenhum vídeo cadastrado.
                    </h1>
                </div>
            )}
        </div>
    );

    return (
        <div className={`w-full h-full ${s.root} ${render ? s.render : ""}`}>
            {/* Backdrop */}
            <div
                className={`w-full h-full absolute top-0 left-0 z-10 pointer-events-none transition-all duration-300 bg-black ${currentSlide > 2 ? "opacity-50" : "opacity-0"}`} />

            <div className={`absolute w-full h-full left-0 top-0 md:container-fluid`}>
                {isUnlocked ? player : (
                    <div className={`${s.placeholder}`}>
                        <button
                            type="button"
                            onClick={handleIsUnlocked}
                            className={`${s.unlockButton}`}
                        >
                            <img
                                src={SSMPlayIcon}
                                alt=""
                            />
                        </button>
                    </div>
                )}
                <div className={`sabin-container h-full hidden md:flex flex-col items-start justify-start relative z-0 select-none pointer-events-none transition-opacity duration-300 ${isUnlocked ? "opacity-0" : "opacity-100"}`}>
                    <div className={`flex flex-col gap-y-6 mt-6 ${s.textBlock}`}>
                        <h1 className={`${s.heading}`}>
                            {selfServiceAttendanceModalData?.stepOneTitle || `Conheça a unidade digital Sabin`}
                        </h1>
                    </div>
                </div>
            </div>
            <div className={`container-fluid w-full h-full`}>
                <div
                    className={`sabin-container h-full pointer-events-none relative transition-all duration-150 ${currentSlide > 2 && "hidden"}`}>
                    <ProgressBar
                        currentSlide={currentSlide}
                        handleCurrentSlide={handleCurrentSlide}
                        TOTAL_SLIDES={TOTAL_SLIDES}
                        hideItems={isUnlocked}
                    />
                </div>
            </div>
        </div>
    )
}

export default SecondSlide;
